<template>
  <div>
    <vue-element-loading
      is-full-screen
      :active="loading"
      spinner="bar-fade-scale"
      color="#152d51"
    />
    <div class="navbar nav-main w-100" style="background-color: #23409a; color: white">
      <h3 class="w-100 text-center my-3">ลงทะเบียนใช้งาน</h3>
    </div>
    <div class="mb-2 flex-all-center session-with-nav">
      <div>
        <v-img
          class="my-0 radius-circle"
          style="width: 170px; height: auto"
          src="@/assets/logo_long.png"
        ></v-img>
      </div>
      <div>
        <v-img
          class="my-0 radius-circle"
          style="width: 170px; height: auto"
          src="@/assets/logo_long_nm.png"
        ></v-img>
      </div>
    </div>
    <div class="w-100 px-8">
      <h6 class="text-blue mb-8 fs-18">เลือกเบอร์โทรศัพท์</h6>
      <div class="text-gray">เบอร์โทรศัพท์ที่ต้องการใช้รับรหัส OTP</div>
      <v-select
        v-model="selectPhoneNo"
        class="mt-5"
        label="เบอร์โทร"
        :items="phoneNoList"
        outlined
        dense
      ></v-select>
      <div class="flex-all-center flex-wrap mt-8">
        <v-btn
          :disabled="!selectPhoneNo"
          :loading="loading"
          @click="nextRegis(selectPhoneNo)"
          class="col-8 main-btn"
          style="color: white"
          color="#23409a"
          >ถัดไป</v-btn
        >
        <v-btn @click="$emit('back')" class="col-8 main-btn mt-3" color="#f5f5f5">ย้อนกลับ</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import { mapGetters } from 'vuex'

export default {
  props: {
    read: {
      default: false
    },
    fetchApi: {
      default: true
    }
  },
  components: { VueElementLoading },
  data() {
    return {
      loading: false,
      checkbox: false,
      htmlData: '',
      selectPhoneNo: null
    }
  },
  async mounted() {},
  methods: {
    async nextRegis(phoneNo) {
      this.$emit('next', phoneNo)
    }
  },
  computed: {
    ...mapGetters(['regisList']),
    phoneNoList() {
      return this.$store?.state?.regisData?.phoneNumbers || []
    },
    query() {
      return this.$store.state.query
    },
    view() {
      return this.$store.state.query.view
    },
    profile() {
      return this.$store.state.profile
    },
    userId() {
      return this.$store.getters.getUserid
    }
  }
}
</script>

<style lang="scss" scoped>
.MsoNormalTable {
  tr,
  td {
    border: 1px solid #454545;
  }
}
</style>
